import { useNavigate } from 'react-router-dom';
import { DraftsList } from '@/components/programs/DraftsList';
import { Button } from '@/components/ui/button';
import { Plus } from 'lucide-react';

export default function ProgramDrafts() {
  const navigate = useNavigate();

  return (
    <div className="container mx-auto py-8">
      <div className="flex justify-between items-center mb-8">
        <div>
          <h1 className="text-3xl font-bold tracking-tight">Program Drafts</h1>
          <p className="text-muted-foreground mt-1">
            Manage your program drafts and create new programs
          </p>
        </div>
        <Button onClick={() => navigate('/programs/create')}>
          <Plus className="h-4 w-4 mr-1" />
          New Program
        </Button>
      </div>

      <DraftsList />
    </div>
  );
} 